module.exports = __webpack_public_path__ + "static/alexis_000-432535335afa086d18edaab237e336d9.jpg";